import { ADDED_LAYER, OBSTACLE_SUBTYPE, OBSTACLE_TYPE } from "./../ENUM.js";
import * as GRADIENT from "./../GRADIENT.js";
import * as SOUND_DATA from "./../SOUND_DATA.js";

export const GNSMK = {
  isDark: true,
  startHealth: 50,
  timeAllowedSecs: 100,
  textColor: "#ffff00",
  textColorHighlight: "#ffffff",
  bgColor: "#b55518",
  bgFadeAlpha: 0.55,
  gameplayAreaToCanvasLateralRatio: 0.9,
  controllerSlipperiness: 5,
  tip: "FOCUS ON DODGING!",
  player: {
    color: "#e8b686",
    growthDivisor: 600,
    radius: 25,
    addedLayer_ar: [
      {
        type: ADDED_LAYER.STETSON,
        colorOuter: "#1f1b00",
        colorInner: "#3e3b27",
        // Following ssizes are given as a proportion of obstacle radius, 0-1
        thickness: 1.3,
        offsetFromCenter: 0.5,
      },
    ],
  },
  obstacles: [
    {
      type: OBSTACLE_TYPE.BACKGROUND,
      total: 200,
      color_ar: ["#ac7548", "#ed9b57", "#994906"],
      radiusRange: [2, 5],
      directionRange: [180, 180],
      speedRange: [1, 1],
    },
    {
      type: OBSTACLE_TYPE.BACKGROUND,
      subtype: OBSTACLE_SUBTYPE.FLOWER,
      total: 7,
      color_ar: ["#ff97d4"],
      radiusRange: [13, 17],
      directionRange: [180, 180],
      speedRange: [1, 1],
      numAppendagesRange: [5, 5],
      shapeCenterRadiusDivisor: 5,
      shapeCenterColor_ar: ["#ffffff"],
    },
    {
      type: OBSTACLE_TYPE.BACKGROUND,
      subtype: OBSTACLE_SUBTYPE.FLOWER,
      total: 20,
      color_ar: ["#559955"],
      radiusRange: [25, 45],
      directionRange: [180, 180],
      speedRange: [1, 1],
      numAppendagesRange: [17, 19],
      shapeCenterRadiusDivisor: 2,
      shapeCenterColor_ar: ["#94b73d"],
    },
    {
      type: OBSTACLE_TYPE.BACKGROUND,
      subtype: OBSTACLE_SUBTYPE.FLOWER,
      total: 13,
      color_ar: ["#55dd55"],
      radiusRange: [65, 95],
      directionRange: [180, 180],
      speedRange: [1, 1],
      numAppendagesRange: [19, 25],
      shapeCenterRadiusDivisor: 1.5,
      shapeCenterColor_ar: ["#8b9241"],
    },
    {
      type: OBSTACLE_TYPE.COLLECT,
      collectSfx_ar: SOUND_DATA.ORDERED_TWANG_SFX_AR,
      subtype: OBSTACLE_SUBTYPE.STAR,
      total: 100,
      color_ar: ["#dddddd", "#ffd200", "#dfa003"],
      gradient: GRADIENT.GOLD_STAR,
      radiusRange: [30, 70],
      directionRange: [120, 240],
      speedRange: [1, 3],
      numAppendagesRange: [5, 5],
      rotationSpeedRange: [0.01, 1],
      shapeCenterRadiusDivisor: 2,
      useDefaultStroke: true,
    },
    {
      type: OBSTACLE_TYPE.AVOID,
      subtype: OBSTACLE_SUBTYPE.SQUARCLE,
      total: 7,
      radiusRange: [11, 16],
      directionRange: [120, 240],
      speedRange: [7, 9],
      gradient: GRADIENT.BULLET,
      useDefaultStroke: true,
    },
    {
      type: OBSTACLE_TYPE.AVOID,
      subtype: OBSTACLE_SUBTYPE.SQUARCLE,
      total: 5,
      radiusRange: [15, 25],
      directionRange: [120, 240],
      speedRange: [7, 9],
      gradient: GRADIENT.BULLET,
      useDefaultStroke: true,
    },
  ],
};
